import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TipoDeBem } from 'src/app/_core/models/tipo-de-bem';
import { TipoDeBemService } from 'src/app/_core/services/tipo-de-bem.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-tipo-de-bens-modal',
  templateUrl: './tipo-de-bens-modal.component.html',
  styleUrls: ['./tipo-de-bens-modal.component.scss']
})
export class TipoDeBensModalComponent implements OnInit {
  @Input() public nR_BPM_TIPO_BEM_PATRIMONIAL!: number;
  title = 'Tela de cadastro de tipo de bens';
  form !: FormGroup;
  tipoDeBem:TipoDeBem;
  loading = true;
  constructor(
    private tipoDeBemService:TipoDeBemService,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    public modalService: NgbModal) { 
      this.tipoDeBem = new TipoDeBem();
    }

  ngOnInit(){
    this.tipoDeBem = new TipoDeBem();
    this.gerarForm(this.tipoDeBem);
    this.loading = false;
    this.carregaTipoBem();
  }
  
  carregaTipoBem(): void {
    if (this.nR_BPM_TIPO_BEM_PATRIMONIAL != 0) {
      this.tipoDeBemService.listarTipoBensById(this.nR_BPM_TIPO_BEM_PATRIMONIAL).subscribe((tipoDeBem) => {
        this.tipoDeBem = tipoDeBem;
        this.gerarForm(this.tipoDeBem);
      });
    }
  }

  gerarForm(tipoDeBem:TipoDeBem){
    this.form = this.fb.group({
      // nR_BPM_TIPO_BEM_PATRIMONIAL:[tipoDeBem.nR_BPM_TIPO_BEM_PATRIMONIAL,[Validators.required]],
      cD_BPM_CLASSE_TIPO_BEM:[tipoDeBem.cD_BPM_CLASSE_TIPO_BEM,[Validators.required]],
      cD_BPM_TUC_TIPO_BEM:[tipoDeBem.cD_BPM_TUC_TIPO_BEM,[Validators.required]],
      cD_BPM_AT1_TIPO_BEM:[tipoDeBem.cD_BPM_AT1_TIPO_BEM,[Validators.required]],
      dS_BPM_DESCRICAO_TIPO_BEM:[tipoDeBem.dS_BPM_DESCRICAO_TIPO_BEM,[Validators.required]],
      dS_BPM_DENOMINACAO_CLASSE_TIPO_BEM:[tipoDeBem.dS_BPM_DENOMINACAO_CLASSE_TIPO_BEM,[Validators.required]],
      vL_BPM_ALIQUOTA_DEPRECIACAO:[tipoDeBem.vL_BPM_ALIQUOTA_DEPRECIACAO,[Validators.required]],
      fL_BPM_ATIVO:[tipoDeBem.fL_BPM_ATIVO,[]],
      fL_BPM_DELETADO:[0,[]]
    })
  }

  submit(){
    this.loading = true;
    var tipoDeBem:TipoDeBem = this.form.value;
    tipoDeBem.cD_BPM_CLASSE_TIPO_BEM = Number(this.form.controls['cD_BPM_CLASSE_TIPO_BEM'].value);
    tipoDeBem.cD_BPM_TUC_TIPO_BEM = Number(this.form.controls['cD_BPM_TUC_TIPO_BEM'].value);
    tipoDeBem.cD_BPM_AT1_TIPO_BEM = Number(this.form.controls['cD_BPM_AT1_TIPO_BEM'].value);
    this.form.get('vL_BPM_DEPRECIACAO_BEM')?.setValue(
      Number(this.form.controls['vL_BPM_DEPRECIACAO_BEM'].value));
    tipoDeBem.fL_BPM_ATIVO = Number(this.form.controls['fL_BPM_ATIVO'].value)
   //console.log/tipoDeBem)
    if(this.form.invalid){
      Swal.fire('Alerta','Olá digite os campos corretamente','warning');
      this.activeModal.close();
      return;
    } else if (this.nR_BPM_TIPO_BEM_PATRIMONIAL == 0) {
      this.tipoDeBemService.insert(tipoDeBem).subscribe((data) => {
        Swal.fire(
          'Adicionado!',
          'Tipo de bem adicionado com sucesso!',
          'success'
        ).then(() => {
          this.form.reset();
          this.loading = false;
          this.activeModal.close();
        });
      },
      (err) =>{
        ////console.log/JSON.stringify(err))
          let msg:string = 'Erro ao cadastrar,tente novamente mais tarde!';
          if(err.status == 401){
            return msg = err.error
          }
          Swal.fire('Erro',msg,'error').then(()=>{
            this.loading = false;
            this.form.reset();
          });
      });
    } else {
      this.tipoDeBemService
      .update(this.nR_BPM_TIPO_BEM_PATRIMONIAL,tipoDeBem)
      .subscribe((data) => {
        Swal.fire(
          'Atualizado!',
          'Tipo de bem atualizado com sucesso!',
          'success'
        ).then(() => {
          this.loading = false;
          this.activeModal.close();
        });
      });
    }
  }
}
